import { SearchResultProduct } from 'store/search/types';

export const LIST_SEARCH_RESULTS_PAGE = 'Search Results Page';

export const gtmSearchProductClickEvent = (design: SearchResultProduct, position: number, extraParams: any) => {
  const productData = {
    ...design,
    name: `design_for_product_id_${design?.productId}`,
    originalName: design?.name,
    list: LIST_SEARCH_RESULTS_PAGE,
    position: Number(position),
  };

  return {
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: {
          list: LIST_SEARCH_RESULTS_PAGE,
        },
        products: [productData],
        list: LIST_SEARCH_RESULTS_PAGE,
        ...extraParams,
      },
    },
  };
};

export default gtmSearchProductClickEvent;
